import * as React from 'react';
import './style.scss'

export default function FullWidth(){
    const logo = require('../../../images/simple-logo.png');

    return (
        <header className="py-5 header-background">
            <img className="img-fluid d-block mx-auto" src={logo} alt="Central Bodyshop"/>           
        </header>
    );
}